const normalize = (value) => String(value || "").trim().toLowerCase()

const mountCardIndexSearch = () => {
  document.querySelectorAll("[data-card-index-search]").forEach((container) => {
    if (container.dataset.cardIndexSearchMounted === "true") return
    container.dataset.cardIndexSearchMounted = "true"

    const input = container.querySelector("[data-card-index-search-input]")
    const emptyState = container.querySelector("[data-card-index-search-empty]")
    const cards = Array.from(container.querySelectorAll("[data-card-index-search-item]"))

    if (!input) return

    const filter = () => {
      const query = normalize(input.value)
      let anyVisible = false

      cards.forEach((card) => {
        const matches = query.length === 0 || normalize(card.dataset.cardIndexSearchText).includes(query)
        card.hidden = !matches
        if (matches) anyVisible = true
      })

      if (emptyState) emptyState.hidden = anyVisible
    }

    input.addEventListener("input", filter)
    filter()
  })
}

export { mountCardIndexSearch }
